import { NgModule } from '@angular/core';
import { OAuthModule } from 'angular-oauth2-oidc'; 
import { AuthService } from './auth.service';


@NgModule({
  providers: [
    AuthService
    //InternalTokenApiService,
    //AppRequestAssistant,
    //INTERNAL_TOKEN_INITIALIZER_PROVIDER,
    //INTERNAL_TOKEN_HEADER_PROVIDER,
    //INTERNAL_API_PREFIX_PROVIDER,
    //PROFILE_INITIALIZER_PROVIDER
  ],
  imports: [OAuthModule.forRoot()]
})
export class AuthModule { }
